module.exports = __webpack_public_path__ + "img/picpay.6b716973.png";